export default __webpack_public_path__ + "static/media/moon-kat.ce6bf21d.jpg";